import React, { Component } from 'react'
import '../styles/Reports.css'
import DropdownWidget from '../widgets/DropdownWidget'
import OrgFooter from '../widgets/OrgFooter'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIGenericRequest from '../api/APIGenericRequest'
import APIReportRequest from '../api/APIReportRequest'
import APIClusterRequest from '../api/APIClusterRequest'
import AlertMessage from '../widgets/AlertMessage'
import InputTextFilterWidget from '../widgets/InputTextFilterWidget'
import DatePicker from '../widgets/DatePicker'

class ReportClusterML extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: localStorage.getItem("siteId"),
			disabled: props.disabled,
			region: user.region,
			province: user.province,
			siteName: localStorage.getItem("siteName"),
		}
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.getMembersByClusterId = this.getMembersByClusterId.bind(this)
		this.getFarmerCommitmentsByClusterIdCropIdAndDate = this.getFarmerCommitmentsByClusterIdCropIdAndDate.bind(this)
		this.getCollectiveMarketingByClusterIdCropIdAndDeliveryDate = this.getCollectiveMarketingByClusterIdCropIdAndDeliveryDate.bind(this)
		this.getServerDateTime = this.getServerDateTime.bind(this)
	}

	getFarmerCommitmentsByClusterIdCropIdAndDate(clid, crid, date, clusterName) {
		const ext = APIReportRequest.getFarmerCommitmentsByClusterIdCropIdAndDate(this.state.accessToken, clid, crid, date)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			response.results.sort((a, b) => {
				return(a.last_name.localeCompare(b.last_name))
			})
			let totalArea = 0
			response.results.map((item, i) => {
				if(item.area_planted != null) {
					totalArea += item.area_planted
				}
			})
			const data = {
				region: this.state.region,
				province: this.state.province,
				siteName: this.state.siteName,
				focusCrop: response.crop.crop_name,
				unit: response.crop.unit_of_measurement,
				clusterName: clusterName,
				commitments: response.results,
				totalArea: totalArea,
				deliveryDate: formatDate(date)
			}
			this.setState({
				data: data,
				showActivityIndicator: false
			})
		})
	}

	getCollectiveMarketingByClusterIdCropIdAndDeliveryDate(clid, crid, date, clusterName) {
		const ext = APIReportRequest.getCollectiveMarketingByClusterIdCropIdAndDeliveryDate(this.state.accessToken, clid, crid, date)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			response.results.sort((a, b) => {
				return(a.last_name.localeCompare(b.last_name))
			})
			let totalArea = 0
			response.results.map((item, i) => {
				if(item.area_planted != null) {
					totalArea += item.area_planted
				}
			})
			const data = {
				region: this.state.region,
				province: this.state.province,
				siteName: this.state.siteName,
				clusterName: clusterName,
				collectiveMarketing: response.results,
				totalArea: totalArea,
				deliveryDate: date
			}
			this.setState({
				data: data,
				showActivityIndicator: false
			})
		})
	}

	getMembersByClusterId(clid) {
		const ext = APIReportRequest.getMembersByClusterId(this.state.accessToken, clid)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			response.results.sort((a, b) => {
				return(a.last_name.localeCompare(b.last_name))
			})
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	handleFooterEvent(e) {
		if(this.state.data == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "No data for export. Please generate report."
			})
			return;
		}
		const dateObj = new Date()
		const month = dateObj.getMonth() + 1
		const date = month + "-" + dateObj.getDate() + "-" + dateObj.getFullYear()
		switch(this.state.typeId) {
			case 1:
				var filename = "CommitmentsPerMember-" + date;
				break
			case 2:
				filename = "CollectiveMarketing-" + date;
				break
			case 3:
				filename = "AETracking-" + date;
				break
			case 4:
				filename = "ClusterMembers-" + date;
		}
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.getServerDateTime(filename)
	}

	getServerDateTime(filename) {
		const apiReq = APIGenericRequest.getServerDateTime(this.state.accessToken)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const dateTime = new Date(response.results.date_time)
			exportToCSV(
				this.state.data,
				filename,
				this.state.typeId,
				this.state.subTypeId,
				this.state.dateRange,
				this.state.year,
				this.state.focusCrop,
				dateTime
			)
		})
	}

	render() {
		const view = <div id="report-site">
			<div className="report-details-left"><FilterReport siteId={this.state.siteId} generate={(v) => {
				switch(v.typeId) {
					case 1:
						this.getFarmerCommitmentsByClusterIdCropIdAndDate(v.clusterId, v.cropId, v.date, v.clusterName)
					break
					case 2:
						this.getCollectiveMarketingByClusterIdCropIdAndDeliveryDate(v.clusterId, v.cropId, v.date, v.clusterName)
					break
					case 3:
					break
					case 4:
						this.getMembersByClusterId(v.clusterId, v.clusterName)
					break
					default:
				}
				this.setState({
					typeId: v.typeId,
					clusterId: v.subTypeId,
					cropId: v.cropId,
					data: null
				})
			}} /></div>
			<div className="report-details-right">
				<ReportContent data={this.state.data} typeId={this.state.typeId} />
				<div className='reports-footer'>
					<OrgFooter eventHandler={this.handleFooterEvent}
						showSubmit={false}
						showExport={true} />
				</div>
			</div>
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class FilterReport extends Component
{
	constructor(props) {
		super(props)
		const date = new Date()
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: localStorage.getItem("siteId"),
			reportType: "COLLECTIVE MARKETING",
			reportSubType: "CLUSTER MEMBERS",
			interval: "YEARLY",
			period: date.getFullYear(),
			types: [
				{id: 1, name: "COMMITMENTS PER MEMBER"},
				{id: 2, name: "COLLECTIVE MARKETING"},
				{id: 3, name: "AE TRACKING"},
				{id: 4, name: "CLUSTER MEMBERS"}
			],
			type: '-- SELECT --',
			cluster: '-- SELECT --',
			crops: JSON.parse(localStorage.getItem("crops")),
			disableDate: true,
			disabledInput: true
		}
		this.getAllClustersBySiteId = this.getAllClustersBySiteId.bind(this)
	}

	componentWillMount() {
		this.getAllClustersBySiteId()
	}

	getAllClustersBySiteId() {
		const clusters = APIClusterRequest.getAllClustersBySiteId(this.state.accessToken, this.state.siteId)
		clusters.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.cluster_id, name: v.cluster_name.toUpperCase()})
			}
			this.setState({clusters: c})
		})
	}

	render() {
		const view = <div className="filter-report">
			<div>Type of Report:</div>
			<DropdownWidget list={this.state.types} placeholder={this.state.type} onItemSelected={(id, val) => {
				let disabledInput = false
				let disableDate = true
				if(id === '4') {
					disabledInput = true
				}
				if(id == '1' || id == '2') {
					disableDate = false
				}
				this.setState({
					typeId: parseInt(id),
					showTypeMSG: false,
					disabledInput: disabledInput,
					disableDate: disableDate
				})
			}} />
			{this.state.showTypeMSG && <div style={{color: '#c96f6f'}}>* Select type of report</div>}
			<br />
			<div>Cluster:</div>
			<DropdownWidget list={this.state.clusters} placeholder={this.state.cluster} onItemSelected={(id, val) => {
				this.setState({
					clusterId: parseInt(id),
					clusterName: val.toUpperCase(),
					showClusterMSG: false
				})

			}} />
			{this.state.showClusterMSG && <div style={{color: '#c96f6f'}}>* Select a cluster</div>}
			<br />
			{(this.state.typeId == 1 || this.state.typeId == 2) && <div>
			<div>Focus Crop:</div>
			<InputTextFilterWidget list={this.state.crops} placeholder={this.state.focusCrop}
				onItemSelected={(id, val) => {
					this.setState({
					cropId: parseInt(id),
					showCropMSG: false
				})
			}} cStyle={{"width": "100%"}} disabled={this.state.disabledInput} />
			{this.state.showCropMSG && <div style={{color: '#c96f6f'}}>* Select a focus crop</div>}
			<br/><br/>
			<div>Date</div>
			<DatePicker onChange={(value) => {
				this.setState({date: value})
			}} value={this.state.date} disabled={this.state.disableDate} />
			{this.state.showDateMSG && <div style={{color: '#c96f6f'}}>* Select a date</div>}
			<br />
			</div>}
			<br />
			<button className="green-two" onClick={(k, v) => {
				let isOK = true
				if(this.state.typeId == null) {
					this.setState({showTypeMSG: true})
					isOK = false
				}
				if(this.state.clusterId == null) {
					this.setState({showClusterMSG: true})
					isOK = false
				}
				if(this.state.cropId == null && this.state.typeId != 4) {
					this.setState({showCropMSG: true})
					isOK = false
				}
				if(!isOK) {
					return
				}
				const filter = {
					typeId: this.state.typeId,
					clusterId: this.state.clusterId,
					clusterName: this.state.clusterName,
					cropId: this.state.cropId,
					date: this.state.date
				}
				this.props.generate(filter)
			}}>GENERATE</button>
			<button className="green-two" onClick={(k, v) => {
				const filter = {
					typeId: null,
				}
				this.props.generate(filter)
				this.setState({
					typeId: null,
					clusterId: null,
					date: null,
					showCropMSG: false,
					showDateMSG: false,
					showTypeMSG: false,
					showClusterMSG: false,
					type: '-- SELECT --',
				})
			}}>CLEAR</button>
		</div>
		return(view)
	}
}

class ReportContent extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state = {
			region: user.region,
			province: user.province,
			siteName: localStorage.getItem("siteName")
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data && this.props.data != null) {
			this.setState({data: this.props.data})
		}
		if(prevProps.clusterName != this.props.clusterName) {
			this.setState({clusterName: this.props.clusterName})
		}
	}

	render() {
		const view = <div id="report-content-site">
			{this.props.data == null && <div className="rcf-content"></div>}
			{this.props.data != null && <div className="rcf-content">
				<div>
				<table className="rcf-table-one">
					<col style={{width: 'auto'}} />
					<col style={{width: 'auto'}} />
					<col style={{width: 'auto'}} />
					<tr>
						<th>REGION</th>
						<th>PROVINCE</th>
						<th>SITE NAME</th>
						<th>CLUSTER NAME</th>
					</tr>
					<tr>
						<td><div>{this.state.region}</div></td>
						<td><div>{this.state.province}</div></td>
						<td><div>{this.state.siteName}</div></td>
						<td><div>{this.state.data?.clusterName}</div></td>
					</tr>
				</table>
				{(this.props.typeId != 3 && this.props.typeId != 4)&& <table className="rcf-table-two">
					<tr>
						<th>FOCUS CROP</th>
						<th>UNIT OF MEASUREMENT</th>
						<th>TOTAL AREA PLANTED (has)</th>
						<th>COMMITMENT DELIVERY DATE</th>
					</tr>
					<tr>
						<td><div>{this.state.data?.focusCrop}</div></td>
						<td><div>{this.state.data?.unit}</div></td>
						<td><div>{this.state.data?.totalArea}</div></td>
						<td><div>{this.state.data?.deliveryDate}</div></td>
					</tr>
				</table>}
				{this.props.typeId == 1 && <CommitmentsPerMember data={this.state.data}/>}
				{this.props.typeId == 2 && <CollectiveMarketing data={this.state.data}/>}
				{this.props.typeId == 3 && <AETracking data={this.state.data}/>}
				{this.props.typeId == 4 && <ClusterMembers data={this.state.data}/>}
			</div>
			</div>}
		</div>
		return(view)
	}
}

const CommitmentsPerMember = (props) => {
	const items = []
	if(props.data?.commitments != null) {
		props.data.commitments.map((item, i) => {
			items.push(<CommitmentsPerMemberItem data={item} key={Math.random()}/>)
		})
	}
	return(<table className="rcf-table-two">
		<tr><th colSpan='5'>COMMITMENTS PER MEMBER</th></tr>
		<tr>
			<th>REGISTRATION NUMBER</th>
			<th>FARMER NAME</th>
			<th>AREA PLANTED (has)</th>
			<th>COMMITMENT VOLUME</th>
			<th>FINAL COMMITMENT VOLUME</th>
		</tr>
		{items}
	</table>)
}

const CommitmentsPerMemberItem = (props) => {
	let mi = ''
	if(props.data.middle_name) {
		mi = ' ' + props.data.middle_name.charAt(0).toUpperCase() + '.'
	}
	let ext = ''
	if(props.data.extension_name) {
		ext = ' ' + props.data.extension_name.toUpperCase()
	}
	const name = `${props.data.last_name.toUpperCase()}, ${props.data.first_name.toUpperCase()}${ext}${mi}`
	return(<tr>
		<td><div>{props.data?.registration_no}</div></td>
		<td><div>{formatName(props.data.first_name, props.data.middle_name, props.data.last_name, props.data.extionsion_name)}</div></td>
		<td><div>{formatNumber(props.data?.area_planted)}</div></td>
		<td><div>{formatNumber(props.data?.supply_commitment)}</div></td>
		<td><div>{formatNumber(props.data?.evaluated_supply)}</div></td>
	</tr>)
}

const CollectiveMarketing = (props) => {
	const items = []
	if(props.data?.collectiveMarketing != null) {
		props.data.collectiveMarketing.map((item, i) => {
			items.push(<CollectiveMarketingItem data={item} key={Math.random()}/>)
		})
	}
	return(<table className="rcf-table-two">
		<tr><th colSpan='14'>COLLECTIVE MARKETING</th></tr>
		<tr>
			<th>REGISTRATION NUMBER</th>
			<th>MEMBER</th>
			<th>VOLUME SOLD</th>
			<th>PRICE PER UNIT</th>
			<th>GROSS SALES</th>
			<th>PRODUCTION COST<br/>PER KILO</th>
			<th>PRODUCTION COST</th>
			<th>POST-HARVEST COST<br/>PER KILO</th>
			<th>POST-HARVERT COST</th>
			<th>GROSS PROFIT</th>
			<th>MARKETING COST<br/>PER KILO</th>
			<th>MARKETING COST</th>
			<th>NET INCOME</th>
			<th>TRADER'S OFFERED<br/>PRICE</th>
		</tr>
		{items}
	</table>)
}

const CollectiveMarketingItem = (props) => {
	let mi = ''
	if(props.data.middle_name) {
		mi = ' ' + props.data.middle_name.charAt(0).toUpperCase() + '.'
	}
	let ext = ''
	if(props.data.extension_name) {
		ext = ' ' + props.data.extension_name.toUpperCase()
	}
	const name = `${props.data.last_name.toUpperCase()}, ${props.data.first_name.toUpperCase()}${ext}${mi}`
	const vs = (props.data.supply_delivered == null)? 0: props.data.supply_delivered
	const ppu = (props.data.price_per_unit == null)? 0: props.data.price_per_unit
	const upc =  (props.data.unit_production_cost == null)? 0: props.data.unit_production_cost
	const uphc = (props.data.unit_post_harvest_cost == null)? 0: props.data.unit_post_harvest_cost
	const mcpk =  (props.data.unit_marketing_cost == null)? 0: props.data.unit_marketing_cost
	const top =  (props.data.trader_offered_price == null)? 0: props.data.trader_offered_price
	const gs = vs * ppu
	const pc = vs * upc
	const phc = vs * uphc
	const gp = gs - pc - phc
	const mc = vs - mcpk
	const ni = gp - mc
	return(<tr>
		<td><div>{props.data?.registration_no}</div></td>
		<td><div>{name}</div></td>
		<td><div>{formatNumber(props.data?.supply_delivered)}</div></td>
		<td><div>{formatNumber(props.data?.price_per_unit)}</div></td>
		<td><div>{formatNumber(gs)}</div></td>
		<td><div>{formatNumber(props.data?.unit_production_cost)}</div></td>
		<td><div>{formatNumber(pc)}</div></td>
		<td><div>{formatNumber(props.data?.unit_post_harvest_cost)}</div></td>
		<td><div>{formatNumber(phc)}</div></td>
		<td><div>{formatNumber(gp)}</div></td>
		<td><div>{formatNumber(props.data?.unit_marketing_cost)}</div></td>
		<td><div>{formatNumber(mc)}</div></td>
		<td><div>{formatNumber(props.data?.gross_income)}</div></td>
		<td><div>{formatNumber(props.data?.trader_offered_price)}</div></td>
	</tr>)
}

const AETracking = (props) => {
	return(<table className="rcf-table-aet">
		<tr><th colSpan='3'>AE STEPS</th></tr>
		<tr>
			<th>STEPS</th>
			<th>DATE ACHIEVED</th>
			<th>ACTIVE MEMBERS</th>
		</tr>
		<tr>
			<td className='step'><div>1.1 FORMATION OF SITE WORKING GROUP</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>1.2 FORMATION OF CLUSTERS</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>1.3 PROFILING OF CLUSTERS</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>1.4 LOCAL RESEARCH TEAM PLANNING</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>2.1 SELECTION OF PRODUCT</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>2.2 PRODUCT MODULE FACILITATION</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>2.3 PRELIMINARY CLUSTER SUPPLY PLANNING</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>3.1 MARKET CNAIN STUDY ORIENTATION</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>3.2 MARKET VISITS AND BUYERS INTERVIEW</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>3.3 MCS INFORMATION CONSOLIDATION</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>3.4 MCS REPORTING TO CLUSTER</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>3.5 DECISION OF TARGET BUYERS</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>4.1 LRT PRESENTATION OF PSA AND MCS</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>4.2 CLUSTER MEMBER COMMITMENTS</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>4.3 CLUSTER POLICIES AND AGREEMENT</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>4.4 FORMAL ORGANIZATION OF CLUSTER</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>5.1 AE PLAN - MARKET PLAN</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>5.2 AE PLAN - SUPPLY PLAN</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>5.3 AE PLAN - MANAGEMENT PLAN</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>5.4 AE PLAN - FINANCIAL PLAN</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>5.5 DECISION ON BUSINESS ACTION SCHEDULES</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>6.1 ACTUAL AGRICULTURAL PRODUCTION</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>6.2 CLUSTER SUPPLY PLAN REVIEW</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>6.3 CLUSTER PRODUCT SUPPLY FORECASTING</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>6.4 PLAN FINALIZATION</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>7.1 SUCCESSFUL NEGOTIATION WITH BUYER</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>7.2 TEST MARKETING PREPARATION</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>7.3 CONDUCT TEST MARKETING</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>7.4 POST-TEST MARKETING ASSESSMENT</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>8.1 SWG PLANNING FOR STEPS 1-7</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
		<tr>
			<td className='step'><div>8.2 ADJUSTMENTS TO AE PLAN</div></td>
			<td><div>{props.data?.date}</div></td>
			<td><div>{props.data?.active_members}</div></td>
		</tr>
	</table>)
}

const ClusterMembers = (props) => {
	const members = []
	if(props.data) {
		props.data.map((item, i) => {
			members.push(<Member data={item} />)
		})
	}
	return(<table className="rcf-table-two">
		<tr><th colSpan='3'>MEMBERS</th></tr>
		<tr>
			<th>REGISTRATION NUMBER</th>
			<th>FARMER</th>
			<th>POSITION</th>
		</tr>
		{members}
	</table>)
}

const Member = (props) => {
	let mi = ''
	if(props.data.middle_name) {
		mi = ' ' + props.data.middle_name.charAt(0).toUpperCase() + '.'
	}
	let ext = ''
	if(props.data.extension_name) {
		ext = ' ' + props.data.extension_name.toUpperCase()
	}
	const name = `${props.data.last_name.toUpperCase()}, ${props.data.first_name.toUpperCase()}${ext}${mi}`
	return(<tr>
		<td><div>{props.data.registration_no.toUpperCase()}</div></td>
		<td><div>{name}</div></td>
		<td><div>{props.data.position}</div></td>
	</tr>)
}

const getYears = () => {
	const years = []
	const date = new Date()
	for(let i=date.getFullYear(); i>1970; i--) {
		years.push({id: i, name: i})
	}
	return years
}

const formatDate = (v) => {
	const dt = new Date(v)
	const d = (dt.getDate().toString().length == 1)? `0${dt.getDate()}`: dt.getDate()
	const m = (`${dt.getMonth()+1}`.length == 1)? `0${dt.getMonth()+1}`: dt.getMonth()+1
	const dFormat = `${m}/${d}/${dt.getFullYear()}`
	return dFormat
}

const formatNumber = (v) => {
	if(v == null) {
		return 0
	}
	const str = `${v}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	return str
}

const formatName = (fn, mn, ln, en) => {
	let mi = ''
	if(mn) {
		mi = ' ' + mn.charAt(0).toUpperCase() + '.'
	}
	let ext = ''
	if(en) {
		ext = ' ' + en.toUpperCase()
	}
	const name = `${ln.toUpperCase()}, ${fn.toUpperCase()}${ext}${mi}`
	return name
}

const exportToCSV = (csvData, filename, typeId, subTypeId, dateRange, year, focusCrop, dateTime) => {
	const dateObj = new Date()
	const month = dateObj.getMonth() + 1
	const dt = dateObj.getDate() - 1
	const date = month + "/" + dt + "/" + dateObj.getFullYear()
	const data = []
	switch(typeId) {
		case 1:
			data.push(["REGION","PROVINCE","SITE NAME", "CLUSTER NAME"])
			data.push([csvData.region.replace(/\s+/g, '%20'),csvData.province.replace(/\s+/g, '%20'),csvData.siteName.replace(/\s+/g, '%20'),csvData.clusterName.replace(/\s+/g, '%20')])
			data.push([])
			data.push(["FOCUS%20CROP","UNIT%20OF%20MEASUREMENT","TOTAL%20AREA%20PLANTED%20(has)","COMMITMENT%20DELIVERY%20DATE"])
			data.push([csvData.focusCrop,csvData.unit,csvData.totalArea,csvData.deliveryDate])
			data.push([])
			data.push(["COMMITMENTS%20PER%20MEMBER"])
			data.push(["REGISTRATION%20NUMBER","FARMER%20NAME","AREA%20PLANTED%20(has)","COMMITMENT%20VOLUME","FINAL%20COMMITMENT%20VOLUME"])
			csvData.commitments.map((item, i) => {
				const name = formatName(item.first_name, item.middle_name, item.last_name, item.extension_name)
				data.push([item.registration_no,`${name}`.replace(/\s+/g, '%20'),item.area_planted,item.supply_commitment,item.evaluated_supply].map(string => string === null ? '' : `\"${string}\"`))
			})
			break
		case 2:
			break
		case 3:
			break
		case 4:
			break
		case 5:
			break
		case 6:
	}
	data.push([])
	data.push(['Date%20Generated: ', `${dateTime.toDateString()} ${dateTime.toLocaleTimeString()}`.replace(/\s+/g, '%20')])
	var csvRow = [];
	for(const v of data) {
		csvRow.push(v.join(","));
	}
	var csvString = csvRow.join("%0A");
	var a = document.createElement('a');
	a.href = 'data:attachment/csv,' + csvString;
	a.target = "_Blank";
	a.download = filename + ".csv";
	a.click();
}

export default ReportClusterML
